export enum LocalizationType {
	KK = 'kk',
	RU = 'ru',
	EN = 'en'
}
